import { useRef } from 'react';
import { motion, useScroll } from 'framer-motion';
import { PROCESS_STEPS } from '@/data/content';
import { Reveal, SectionHeading } from '@/components/Reveal';

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start 0.7', 'end 0.6'] });

  return (
    <section data-testid="process-section" className="py-24 sm:py-32">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <SectionHeading chapter="07" label="How It Works" title={<>From first call to <span className="italic text-champagne">final cheer</span></>} />

        <div ref={ref} className="mt-20 relative">
          <div className="absolute left-[7px] sm:left-1/2 top-0 bottom-0 w-px bg-white/10" />
          <motion.div
            style={{ scaleY: scrollYProgress }}
            className="absolute left-[7px] sm:left-1/2 top-0 bottom-0 w-px bg-champagne origin-top"
          />
          <div className="space-y-16 sm:space-y-24">
            {PROCESS_STEPS.map((s, i) => (
              <Reveal key={s.num} className={`relative grid sm:grid-cols-2 gap-4 sm:gap-16 items-start ${i % 2 === 1 ? '' : ''}`}>
                <span className={`absolute top-1 left-0 sm:left-1/2 sm:-translate-x-1/2 w-[15px] h-[15px] rounded-full border-2 border-champagne bg-ink`} />
                <div className={`pl-10 sm:pl-0 ${i % 2 === 1 ? 'sm:order-2 sm:text-left' : 'sm:text-right'}`}>
                  <p className="font-serif text-6xl sm:text-7xl font-light text-champagne/25">{s.num}</p>
                </div>
                <div className={`pl-10 sm:pl-0 ${i % 2 === 1 ? 'sm:order-1 sm:text-right' : ''}`}>
                  <h3 className="font-serif text-2xl sm:text-3xl font-light uppercase tracking-[0.15em] text-cream">{s.title}</h3>
                  <p className="mt-3 text-white/60 font-light leading-relaxed">{s.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
